import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';

/* actions */
import * as Actions from '../../redux/actions';
import * as Popups from '../../constants/popup-types';

import store from '../../redux';

class hotAddUser extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'hot Add User';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        payload.platform = 'website'
        // this.call(this.Config.api.requests.hotAddUser, payload);
        this.call(this.Config.api.requests.register, payload, 'post', {
            //local
            // basePath: 'http://localhost:9000/users/api/auth',
            //dev
            basePath: '//' + window.apiUrl + '/users/api/auth',
            stringifyData: true,
        });
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        const userData =  this.response.data;
        AnalyticsManager.updateUserProperties(userData);
        AnalyticsManager.logRegister(userData);
        this.dispatch(Actions.setUserData(userData));

        const state = store.getState();

        this.dispatch(Actions.addPopup({
            type: Popups.GENERAL_MESSAGE,
            text: state.config.Translations['first_login_user_message'],
        }))
    }
}


export default hotAddUser;
